import {ref} from "vue";

export type OfferStates = Record<string, string>
export const offerStates = ref<OfferStates>({})
